// extracted by mini-css-extract-plugin
export default {"charm":"c0vbWH0EYI8xqltoEIrw","charmDetail":"v1UDwO0B5_QU3uErYzXw","charmDescription":"GNoemQccJOZWNJRqXx9d"};